import { render, staticRenderFns } from "./LocalisationMap.vue?vue&type=template&id=23b37368&scoped=true"
import script from "./LocalisationMap.vue?vue&type=script&lang=js"
export * from "./LocalisationMap.vue?vue&type=script&lang=js"
import style0 from "./LocalisationMap.vue?vue&type=style&index=0&id=23b37368&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b37368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b37368')) {
      api.createRecord('23b37368', component.options)
    } else {
      api.reload('23b37368', component.options)
    }
    module.hot.accept("./LocalisationMap.vue?vue&type=template&id=23b37368&scoped=true", function () {
      api.rerender('23b37368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Localisation/LocalisationMap.vue"
export default component.exports